import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/siteConfig';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
export function ClosingInvitation() {
  const goTo = useAnchorNavigation();
  const {
    support
  } = siteConfig;
  return <section aria-labelledby="closing-title" className="bg-ink text-canvas" data-id="element-148" data-mp="uspg0q8xsjvh">
      <div className="mx-auto grid max-w-page items-end gap-12 px-5 py-20 md:px-10 lg:grid-cols-[1.4fr_1fr] lg:py-24" data-id="element-149" data-mp="qs5g5ewzb25n">
        <div data-id="element-150" data-mp="lzcdcwl2m3w7">
          <h2 id="closing-title" className="font-display text-[44px] font-medium leading-[1.05] md:text-[64px]" data-id="element-151" data-mp="lysu9cjop9gl">
            Ready When You Are.
          </h2>
          <p className="mt-5 max-w-lg text-[17px] leading-relaxed text-canvas/80" data-id="element-152" data-mp="c3shga6ib57g">
            Bring the AuraGlow Luxe mask home, or talk to our team first. We’re glad to help.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-153" data-mp="32ue7u3w71px">
            <a href="/#the-mask" onClick={goTo('the-mask')} className={buttonClasses('inverse')} data-id="element-154" data-mp="1wa6sbtgjiq71">
              Shop the mask
            </a>
            <Link to="/contact" className={buttonClasses('inverse-outline')} data-id="element-155" data-mp="211f06l2823i3">
              Contact support
            </Link>
          </div>
        </div>
        <div className="border-t border-canvas/25 pt-6" data-id="element-156" data-mp="1rakepiwsv7xp">
          <p className="text-[14px] text-champagne" data-id="element-157" data-mp="1rb3ky2d387vw">Call us</p>
          <a href={support.phoneHref} className="mt-1 inline-flex min-h-[44px] items-center font-display text-3xl hover:text-champagne" data-id="element-158" data-mp="2f05008gfeha5">
            {support.phone}
          </a>
          <dl className="mt-3 space-y-1 text-[14px] text-canvas/80" data-id="element-159" data-mp="260016mpasr7l">
            {support.hours.map(h => <div key={h.days} className="flex justify-between gap-4" data-id="element-160" data-mp="2a0sa1eu9cu3c">
                <dt data-id="element-161" data-mp="ukkuusb78mzt">{h.days}</dt>
                <dd data-id="element-162" data-mp="ukbdft47zo5q">{h.time}</dd>
              </div>)}
          </dl>
          <p className="mt-2 text-[13px] text-canvas/70" data-id="element-163" data-mp="ylwpxdcue0fe">All times {support.timezone}.</p>
        </div>
      </div>
    </section>;
}